import { validateEmail } from 'utils/validations'

/**
 * Identifies alertContainer type (exit / regular) and returns respective texts to be rendered on alertHeader
 * @param {boolean} exitModal AlertContainer prop which indicates if it's exit modal or regular alert modal
 * @returns {object} object containing notificationBox (component) title and message to be rendered, each modal (exit / regular alert) have their own texts.
 * @author Leandro Parisi
 * @since 2021.03.26
 */
export const getNotificationBoxTexts = exitModal => {
  const title = exitModal ? 'Não encontrou o que procurava?' : 'Criar um alerta'
  const message = exitModal
    ? 'Antes de sair crie um cadastro baseado na sua última busca ou com filtros diferentes'
    : 'Nosso alerta vai encontrar as melhores ofertas no seu perfil.'

  return { title, message }
}

/**
 * Receives periodicity global state and returns correspondent props to be used on alertModal
 * @param {object} periodicity alert state key
 * @returns {object} payload with {somePeriodicityChecked, options} beeing: somePeriodicityChecked: verification used on getIsDisabled; options: checkbox metadata to be rendered on alertModal component
 * @author Leandro Parisi
 * @since 2021.03.26
 */
export const getPeriodicityProps = periodicity => {
  const somePeriodicityChecked = Object.values(periodicity).some(p => p)

  const options = [
    {
      label: 'Quando disponível',
      value: 'avaiable',
      checked: periodicity.avaiable,
    },
    {
      label: 'No máximo uma vez por dia',
      value: 'daily',
      checked: periodicity.daily,
    },
    {
      label: 'No máximo uma vez por semana',
      value: 'weekly',
      checked: periodicity.weekly,
    },
  ]

  return { somePeriodicityChecked, options }
}

/**
 * Checks if user has filled all required fields of given alertModal
 * @param {bollean} isLoading AlertContainer state which tells if fetch has been completed or is beeing processed
 * @param {object} $alert alert global state
 * @param {boolean} somePeriodicityChecked indicates if user has checked any of periodicity checkboxes options
 * @returns {boolean} used on and if inside AlertContainer handleConfirm to control if user has filled all required field of given alertModal
 * @author Leandro Parisi
 * @since 2021.03.26
 */
export const getConfirmCheck = (
  isLoading,
  { email, whatsapp, phone },
  somePeriodicityChecked = true
) => {
  return (
    isLoading ||
    !validateEmail(email) ||
    (whatsapp && phone.replace(/[^0-9]/g, '').length !== 11) ||
    !somePeriodicityChecked
  )
}

/**
 * Controls if alertModal confirm button should be enabled or disabled
 * @param {object} $alert alert global state
 * @param {boolean} somePeriodicityChecked indicates if user has checked any of periodicity checkboxes options
 * @returns {function} highOrder function which expects checkOffersResale, which will only be given inside AlertModal to complement boolean check
 * @author Leandro Parisi
 * @since 2021.03.26
 */
export const getIsDisabled = (
  { email, whatsapp, phone },
  somePeriodicityChecked = true
) => checkOffersResale => {
  return (
    !validateEmail(email) ||
    (whatsapp && phone.replace(/[^0-9]/g, '').length !== 11) ||
    !somePeriodicityChecked ||
    !checkOffersResale
  )
}
